// extracted by mini-css-extract-plugin
export default {"host":"DecimalInput_host__-LxzL"};